<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="findHighlightAll" tabindex="0" />
  <label for="findHighlightAll" data-l10n-id="pdfjs-find-highlight-checkbox"></label>
</div>
